import { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toolbar } from 'primereact/toolbar';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dialog } from 'primereact/dialog';
import { AnexosComponent } from '../../../components/AnexosComponent';
import { DatosGeneral } from './secciones/DatosGeneral';
import { DatosRepresentante } from './secciones/DatosRepresentante';
import { DatosPep } from './secciones/DatosPep';
import { Declaracion } from './secciones/Declaracion';
import { useToken } from '../../../components/useToken';
import { Proveedor } from '../../../models/Proveedor';
import { ProveedorService } from '../../../service/ProveedorService';
import { FiltroMultiempresa } from '../../../components/FiltroMultiempresa';
import * as generic from '../../../components/Generico';
import { useLazyParams } from '../../../hooks/useLazyParams';
import { TablaDinamica } from '../../../components/TablaDinamica';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { Card } from 'primereact/card';
import { DialogInstrucciones } from '../../../components/ui/DialogInstrucciones';

export const InfoProveedor = () => {
    const [catalogos, setCatalogos] = useState(null);
    const omodel = new Proveedor({ formularioMatriz: catalogos?.formularioMatriz });
    const toast = useRef(null);
    const proveedorServicio = new ProveedorService();
    const { getPerss, getRol } = useToken();
    // Estados Globales del Formulario
    const [proveedor, setProveedor] = useState(null);
    const [permss, setPermss] = useState(null);
    // Estados de navegación y UI
    const [dialogProveedor, setDialogProveedor] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [siCliente, setSiCliente] = useState(false);
    const [empresa, setEmpresa] = useState(null);
    const [urls, setUrls] = useState(null);
    const [dialogAnexos, setDialogAnexos] = useState(false);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const menuRef = useRef(null);
    const topRef = useRef(null);
    const [mostrarRegresarFlotante, setMostrarRegresarFlotante] = useState(false);
    const [dialogInstruccion, setDialogInstruccion] = useState(false);
    const [soloLectura, setSoloLectura] = useState(false);

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/proveedor',
            urlDownload: 'ficha/proveedor/descarga',
            urlUpload: 'ficha/proveedor/store',
            udelete: 'ficha/proveedor/eliminar-anexo',
            uactual: 'ficha/proveedor/editar',
            uenviar: 'ficha/proveedor/enviar',
            uaprobar: 'ficha/proveedor/aprobar',
        });

        const permisosToken = getPerss();
        const esClienteNotificado = permisosToken !== undefined;
        setSiCliente(esClienteNotificado);
        if (esClienteNotificado) { // FLUJO CLIENTE NOTIFICADO
            setPermss(permisosToken);  // Al tener permisos en el token, se asignan y se le redirige directamente  a su propia ficha enviando ID 0 (el backend resolverá su registro).
            editFicha(true); // Es un usuario notificado
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const esClienteNotificado = getPerss() !== undefined;
        // Solo cargamos la lista si es un usuario interno
        if (!esClienteNotificado) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    // Efecto para observar el inicio del formulario
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setMostrarRegresarFlotante(!entry.isIntersecting);
            },
            { threshold: 0 }
        );
        const currentRef = topRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [dialogProveedor]); // Dependencia clave: se re-ejecuta cuando abre/cierra el formulario


    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        delete _lazyParams.empresa;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (empresa) {
            _lazyParams.empresa = empresa;
        }
        const rol = getRol();
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            tablaEstado.setLoading(false);
            return;
        } else {
            _lazyParams.rol = rol;
        }
        proveedorServicio.getLista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const iniciarNuevo = () => { // Los catalogos ya existen puesto que se cargan en el index para usuarios internos
        setSoloLectura(false);
        setDialogProveedor(true);
        setProveedor(null); // Limpiamos el actual
        setActiveIndex(0);
        setDialogInstruccion(true);
    }

    const editFicha = (esNotificado = false, isReadOnly = false) => {
        setSoloLectura(isReadOnly);
        const idConsulta = esNotificado ? 0 : proveedor?.id;
        const necesitaCatalogos = catalogos === null;
        proveedorServicio.consultarProveedor(idConsulta, { necesitaCatalogos: necesitaCatalogos }).then(res => {
            if (necesitaCatalogos && res.data.catalogos) {
                setCatalogos(res.data.catalogos);
            }
            if (!res.data.proveedor) {
                iniciarNuevo();
                return;
            }
            setDialogProveedor(true);
            setActiveIndex(0);
            setDialogInstruccion(true);
            // Sincronizamos el estado principal con lo que necesitamos para navegar
            nuevoProveedor({
                id: res.data.proveedor.id,
                nemonico: res.data.proveedor.nemonico,
            });
        }).finally(() => {

        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el formulario?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteProveedor()
        });
    }

    const deleteProveedor = () => {
        proveedorServicio.eliminarProveedor(proveedor.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    // FUNCIÓN VITAL PARA MANTENER SINCRONIZADAS LAS TABS
    const nuevoProveedor = (nuevo) => {
        if (!nuevo) {
            setProveedor(null);
            return;
        }
        setProveedor(prev => ({ ...prev, ...nuevo }));
    }

    const handleNext = () => { if (activeIndex < 3) setActiveIndex(activeIndex + 1); };
    const handlePrev = () => { if (activeIndex > 0) setActiveIndex(activeIndex - 1); };

    const regresar = () => {
        setActiveIndex(0);
        setDialogProveedor(false);
        setSoloLectura(false);
        if (!siCliente) loadLazyData();
    }

    const reiniciar = () => {
        if (!siCliente) loadLazyData();
        setDialogProveedor(false);
        setDialogAnexos(false);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.consultar) {
            items.push({ label: 'Ver', icon: 'pi pi-eye', command: () => { editFicha(false, true); } });
        }
        if (permss?.actualizar && (proveedor?.nemonico === 'BORRADOR' || proveedor?.nemonico === 'ENVIADO')) {
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        }
        if (permss?.consultar) items.push({ label: 'Anexos formulario', icon: 'pi pi-folder-open', command: () => { setDialogAnexos(true) } });
        if (permss?.eliminar && proveedor?.nemonico === 'BORRADOR') {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setProveedor(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    const panelHeaderTemplate = (options) => (
        <div className="p-panel-header flex justify-content-between align-items-center flex-wrap gap-2 w-full">
            <div>
                <h3 className="m-0 text-xl font-bold p-text-secondary flex align-items-center">
                    <i className="pi pi-folder-open mr-2"></i>
                    <span className="mr-2">{proveedor?.id ? 'EDITAR' : 'NUEVO'} FORMULARIO DE INFORMACIÓN DEL PROVEEDOR</span>
                    <Button type="button" icon="pi pi-question-circle" className="p-button-rounded p-button-text p-button-sm p-0 m-0 text-white hover:text-blue-200 transition-colors transition-duration-200"
                        style={{ width: '2rem', height: '2rem' }} onClick={() => setDialogInstruccion(true)} tooltip="Ver instrucciones" tooltipOptions={{ position: 'right' }} />
                </h3>
            </div>
            {!siCliente && (
                <Button tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} icon="pi pi-arrow-left" onClick={regresar} />
            )}
        </div>
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            {!dialogProveedor && !siCliente && (
                <div className="fadein animation-duration-300">
                    {getRol() && getRol()?.ideg && (
                        <div className="mb-3">
                            <FiltroMultiempresa loadLazyData={loadLazyData} setEmpresa={setEmpresa} />
                        </div>
                    )}
                    <Toolbar className="mb-4 shadow-1 border-round" start={generic.leftToolbarTemplate(iniciarNuevo, 'Nuevo', permss)} end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Listado_proveedor', 'LISTADO INFORMACIÓN PROVEEDOR')} />
                    <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                        <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
                    </Card>
                </div>
            )}
            {dialogProveedor &&
                <div className="fadein animation-duration-300">
                    <Panel headerTemplate={panelHeaderTemplate} className="panel-ficha shadow-2">
                        <div ref={topRef} style={{ position: 'absolute', top: '0', left: '0', width: '1px', height: '80px', pointerEvents: 'none', visibility: 'hidden' }} />
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="form-tabview">
                            <TabPanel header="Sección 1" leftIcon="pi pi-id-card mr-2" disabled={proveedor == null}>
                                <DatosGeneral next={handleNext} permss={permss} catalogos={catalogos} toast={toast}
                                    nuevoProveedor={nuevoProveedor} id={proveedor?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 2" leftIcon="pi pi-users mr-2" disabled={!proveedor?.id}>
                                <DatosRepresentante handlePrev={handlePrev} next={handleNext} permss={permss}
                                    catalogos={catalogos} toast={toast} nuevoProveedor={nuevoProveedor}
                                    id={proveedor?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 3" leftIcon="pi pi-shield mr-2" disabled={!proveedor?.id}>
                                <DatosPep handlePrev={handlePrev} next={handleNext} permss={permss}
                                    catalogos={catalogos} toast={toast} nuevoProveedor={nuevoProveedor}
                                    id={proveedor?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 4" leftIcon="pi pi-file-check mr-2" disabled={!proveedor?.id}>
                                <Declaracion handlePrev={handlePrev} permss={permss} catalogos={catalogos} toast={toast}
                                    id={proveedor?.id} urls={urls} estado={proveedor?.nemonico} setDialogAnexos={setDialogAnexos}
                                    reiniciar={reiniciar} soloLectura={soloLectura} />
                            </TabPanel>
                        </TabView>
                    </Panel>

                    {mostrarRegresarFlotante && !siCliente && (
                        <div className="fadein scalein" style={{ position: 'fixed', top: '65px', right: '30px', zIndex: 999 }}>
                            <Button icon="pi pi-arrow-left" onClick={regresar} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} />
                        </div>
                    )}
                </div>
            }

            <DialogInstrucciones visible={dialogInstruccion} onHide={() => setDialogInstruccion(false)} title={omodel.titulo} items={omodel.pasosInstrucciones} />
            <Dialog visible={dialogAnexos} header="Gestión de Anexos" modal className="p-fluid modal-ssize" onHide={() => setDialogAnexos(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="proveedor" urls={urls} idp={proveedor?.id} toast={toast} permss={permss} setDialogSubir={setDialogAnexos} reiniciar={reiniciar} estado={proveedor?.nemonico} soloLectura={soloLectura} />
            </Dialog>
        </>
    )
}